module.exports = __webpack_public_path__ + "img/icon-add.b073a7bf.svg";